export default "__VITE_ASSET__BcSSTQys__";